import { useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Trash2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { brandAsset } from "@/lib/brand";
import { LogoImg } from "@/components/LogoImg";

export function LeagueIcon({ l, className = "h-12 w-12 rounded-xl", testId }) {
  if (l.icon_url) return <LogoImg src={brandAsset(l.icon_url)} fit={l.icon_fit} alt={`Logo ${l.name}`} className={`${className} shrink-0`} testId={testId} />;
  return <span className={`${className} flex shrink-0 items-center justify-center bg-[#B7F52A]/10 font-display text-xl font-extrabold text-[#B7F52A]`} data-testid={testId}>{l.name[0]?.toUpperCase()}</span>;
}

export function LeagueIconField({ league, reload }) {
  const [busy, setBusy] = useState(false);
  const run = async (fn, ok) => { setBusy(true); try { await fn(); toast.success(ok); reload(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); } };
  const upload = (file) => { const fd = new FormData(); fd.append("file", file); run(() => api.post(`/leagues/${league.id}/icon`, fd), "Logo de la ligue enregistré"); };
  return (
    <section className="mpl-card space-y-3 p-4" data-testid="league-icon-section">
      <h2 className="text-base font-bold">Logo de la ligue</h2>
      <p className="text-xs text-slate-400">Image carrée recadrée automatiquement, affichée dans Mes ligues et en haut de la ligue. {league.brand ? "Sans image, le logo de l'entreprise est utilisé." : "Sans image, la lettre de la ligue est affichée."}</p>
      <div className="flex flex-wrap items-center gap-3">
        <LeagueIcon l={league} className="h-16 w-16 rounded-2xl" testId="league-icon-preview" />
        <label className={`mpl-btn-ghost cursor-pointer text-sm ${busy ? "pointer-events-none opacity-60" : ""}`}><ImagePlus size={14} /> {league.icon_custom ? "Changer l'image" : "Ajouter une image"}
          <input type="file" accept="image/jpeg,image/png,image/webp" className="hidden" data-testid="league-icon-input" onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) upload(f); }} />
        </label>
        {league.icon_custom && <button type="button" disabled={busy} onClick={() => run(() => api.delete(`/leagues/${league.id}/icon`), "Image retirée")} className="text-xs text-rose-300 hover:underline" data-testid="league-icon-remove"><Trash2 size={12} className="inline" /> Retirer</button>}
      </div>
    </section>
  );
}
